<!-- version 2021/05/20 -->
<template>
  <span>{{ text }}</span>
</template>

<script>
export default {
  props: {
    text: String
  }
};
</script>

<style lang="sass" scoped>
    span
        font-weight: bold
        font-size: 18px
        color: #002832
</style>